<template>
  <main>
    <organism-qr-access-detail
    ></organism-qr-access-detail>
  </main>
</template>

<script>
import OrganismQrAccessDetail from "@/components/organisms/portal/internal/qrAccess/OrganismQrAccessDetail.vue"

export default {
  name: "QrAccessDetail",
  components: { OrganismQrAccessDetail },
}
</script>

<style lang="scss" scoped></style>
